<template>
    <div class="list-member">
        <label for="">Danh sách học sinh trong nhóm</label>
        <b-table striped hover :fields="fieldsTableMember" :items="listMember">
            <template #head(stt)="data">
                <span class="col-table">{{ data.label }}</span>
            </template>

            <template #head(name)="data">
                <span class="col-table">{{ data.label }}</span>
            </template>  
            
            <template #cell(name)="data">
                <router-link :to="{ path: 'thong-ke-hoc-sinh', query: { userId: data.item.userId }}" target="_blank" class="text-default">
                    <strong  style="color:green">{{ data.item.name }}</strong>
                </router-link>
            </template>
        </b-table>
        
    </div>
</template>
<script>
import { getListMemberByGroupId } from './../../_api/classSchoolGroupUserServices'

export default{
    props:{
        classSchoolGroupId:{
            type:Number,
            default:0
        }
    },
    watch:{
        'classSchoolGroupId':'getListMemberByGroupId'
    },
    data(){
        return{
            fieldsTableMember:[{key:'stt',label:'STT'},{key:'name',label:'Họ tên học sinh'}],
            listMember: [],
        }
    },
    mounted(){
        this.getListMemberByGroupId()
    },
    methods:{
        getListMemberByGroupId(){
            this.listMember=[]
            let groupId = this.classSchoolGroupId
            getListMemberByGroupId(groupId).then((res)=>{
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        this.listMember.push({'id':item.id, 'stt':i+1,'name': item.userName,userId:item.userId },)
                    }
                }
            })
        }
    }
}
</script>